import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { RootState } from 'cityads-v3/types/reducer'

import {
  toggleMenu,
} from 'cityads-v3/actions/menu'

import {
  MENU_LINKS
} from 'cityads-v3/components/Header/HeaderToolbar'

import Icon from '@mui/material/Icon'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Tooltip from 'cityads-v3/components/Tooltip/Tooltip'

import KeyboardArrowLeftOutlinedIcon from '@mui/icons-material/KeyboardArrowLeftOutlined'
import KeyboardArrowRightOutlinedIcon from '@mui/icons-material/KeyboardArrowRightOutlined'

export default function MenuContentGuest() {
  const { t } = useTranslation(['main'])
  const dispatch = useDispatch()
  const language = useSelector((state: RootState) => state.language.language)
  const docked = useSelector((state: RootState) => state.menu.docked)
  const isMobile = useSelector((state: RootState) => state.app.isMobile)

  const handleToggleMenu = useCallback((open, docked = false) => () => {
    dispatch(toggleMenu(open, docked))
  }, [dispatch])

  return (
    <List>

      {!isMobile && <ListItem sx={{ p: 0 }}>
        <ListItemButton
          onClick={handleToggleMenu(false, !docked)}
        >
          <ListItemIcon>
            {docked ? <KeyboardArrowLeftOutlinedIcon /> : <KeyboardArrowRightOutlinedIcon />}
          </ListItemIcon>
        </ListItemButton>
      </ListItem>}

      {MENU_LINKS
        .filter(({ requireLanguages }) => {
          if (requireLanguages && !requireLanguages.includes(language)) {
            return false
          }
          return true
        })
        .map(({ to, title, icon }) => {
          const listItem = (
            <ListItem
              key={to}
              sx={{ p: 0 }}
            >
              <ListItemButton
                component={Link}
                to={to}
                onClick={handleToggleMenu(false)}
              >
                <ListItemIcon>
                  <Icon>{icon}</Icon>
                </ListItemIcon>
                {(docked || isMobile) && <ListItemText primary={t(title)} />}
              </ListItemButton>
            </ListItem>
          )

          return docked ? listItem : (
            <Tooltip
              key={to}
              isLight
              title={t(title)}
              placement="right"
            >
              {listItem}
            </Tooltip>
          )
        })
      }

    </List>
  )
}
